/*
 * @Author: Chu Yifei
 * @LastEditors: Chu Yifei
 */
import zh from '../KS/zh'

export default {
  ...zh,
}
